import React from 'react';
import styled from 'styled-components';
import GetStartedHeading from './GetStartedHeading';
import GetStartedActions from './GetStartedActions';
import GetStartedActionLinks from './GetStartedActionLinks';
import GetStartedResourceLinks from './GetStartedResourceLinks';

const Container = styled.div`
  flex: 0 0 auto;
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 16px;
  height: 120px;
  padding: 16px;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background-image: url('/images/get-started-banner.jpg');
    background-position: top left;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: -1;
    body.dark & {
      filter: invert(1) hue-rotate(180deg);
    }
  }
`;
const FirstWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const GetStarted = () => (
  <Container>
    <FirstWrapper>
      <GetStartedHeading />
      <GetStartedActions />
    </FirstWrapper>
    <GetStartedActionLinks />
    <GetStartedResourceLinks />
  </Container>
);

export default GetStarted;
